var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubbleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 2.09473H3.33073C2.41406 2.09473 1.66406 2.86783 1.66406 3.81272V19.2747L4.9974 15.8387H16.6641C17.5807 15.8387 18.3307 15.0656 18.3307 14.1207V3.81272C18.3307 2.86783 17.5807 2.09473 16.6641 2.09473ZM15.8307 14.1207H4.9974L3.33073 15.8387V4.67172C3.33073 4.19927 3.70573 3.81272 4.16406 3.81272H15.8307C16.2891 3.81272 16.6641 4.19927 16.6641 4.67172V13.2617C16.6641 13.7342 16.2891 14.1207 15.8307 14.1207Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleOutline);
export default __webpack_public_path__ + "static/media/chat-bubble-outline.699b320e537ac290096de1c56dae9680.svg";
export { ForwardRef as ReactComponent };